/**
 * Hosts that serve ONLY the public draw router (draw.pdpo.ai in production,
 * draw.localhost for local testing via /etc/hosts or Chromium's built-in
 * *.localhost resolution).
 */
export const DRAW_HOST_BASES = ['draw.pdpo.ai', 'draw.localhost'];

export function isDrawHost(hostname: string): boolean {
  return DRAW_HOST_BASES.includes(hostname);
}
